module.exports = __webpack_public_path__ + "img/map-1-f@2x.f96e7ede.png";